/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import {
  createArrayWithSequence,
  showAsCurrency
} from '../../utils'

const getLinks = (currentPage, numberOfPages, resultsPerPage) => {
  let pagesLeft = numberOfPages - currentPage
  let links = numberOfPages <= 5
    ? createArrayWithSequence(numberOfPages)
    : [...createArrayWithSequence(5), '...', numberOfPages]

  if (currentPage > 5) {
    if (pagesLeft < 5) {
      links = [1, '...', ...createArrayWithSequence(5, numberOfPages - 4)]
    } else {
      links = [1, '...', ...createArrayWithSequence(3, currentPage - 1), '...', numberOfPages]
    }
  }

  return links
}

const getInitialState = ({ currentPage, numberOfPages, resultsPerPage }) => (
  { links: getLinks(currentPage, numberOfPages, resultsPerPage) }
)

class PageRange extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number,
    totalCount: PropTypes.number.isRequired,
    totalAmountIncl: PropTypes.string,
    numberOfPages: PropTypes.number.isRequired,
    resultsPerPage: PropTypes.number.isRequired,
    resultsText: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string
  }

  static defaultProps = {
    currentPage: 1,
    resultsText: 'results',
    className: ''
  }

  state = getInitialState(this.props)

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.currentPage !== this.props.currentPage || prevProps.resultsPerPage !== this.props.resultsPerPage) {
      this.setState({
        links: getLinks(this.props.currentPage, this.props.numberOfPages, this.props.resultsPerPage)
      })
    }
  }

  render() {
    let { currentPage, totalCount, totalAmountIncl, resultsText, onClick, className } = this.props
    return (
      <div className={`slds-p-left_x-small slds-p-right_x-small ${className}`}>
        <div className='slds-p-top_xx-small slds-grid'>
          {this.state.links.map((pageNumber, index) => (
            pageNumber === '...'
              ? <div className='u-font-size-large page-range-link' style={{ border: 'none' }} key={`pageRange_${index}_${pageNumber}`}>
                  {pageNumber}
                </div>
              : <div
                  onClick={() => onClick(pageNumber)}
                  className={`u-font-size-large hover ${currentPage === pageNumber ? 'page-range-link current u-font-weight-bold' : 'page-range-link clickable'}`}
                  key={pageNumber}>
                  {pageNumber}
                </div>
          ))}
        </div>
        <div className='slds-grid slds-wrap slds-text-color_weak slds-m-top_xx-small' style={{ justifyContent: 'space-around' }}>
          <div>{`${totalCount} ${resultsText}`}</div>
          {totalAmountIncl &&
            <div className='slds-p-left_medium'>
              {`Total ${showAsCurrency('R', totalAmountIncl, 2, true)}`}
            </div>
          }
        </div>
      </div>
    )
  }
}

export default withRouter(PageRange)



// WEBPACK FOOTER //
// ./src/components/page-navigation-buttons/PageRange.js